import $ from "jquery";
import L from "leaflet";
function trimString(s) {
    var l = 0, r = s.length - 1;
    while (l < s.length && s[l] == ' ')
        l++;
    while (r > l && s[r] == ' ')
        r -= 1;
    return s.substring(l, r + 1);
}
function compareObjects(o1, o2) {
    var k = '';
    for (k in o1)
        if (o1[k] != o2[k])
            return false;
    for (k in o2)
        if (o1[k] != o2[k])
            return false;
    return true;
}
function itemExists(haystack, needle) {
    for (var i = 0; i < haystack.length; i++)
        if (compareObjects(haystack[i], needle))
            return true;
    return false;
}
function searchFor(toSearch, objects) {
    var results = [];
    // toSearch = trimString(toSearch); // trim it
    // console.log(objects);
    for (var i = 0; i < objects.length; i++) {
        for (var key in objects[i]) {
            if (objects[i][key].indexOf(toSearch) != -1) {
                if (!itemExists(results, objects[i]))
                    results.push(objects[i]);
            }
        }
    }
    return results;
}
$(document).ready(() => {
    if ($("#map-lf").length) {
        let map = L.map('map-lf', {
            zoomControl: false,
            minZoom: 8,
            maxZoom: 12
        });
        map.eachLayer(function (layer) {
            map.removeLayer(layer);
        });
        // map.touchZoom.disable();
        map.scrollWheelZoom.disable();
        map.on('click', function () {
            if (map.scrollWheelZoom.enabled()) {
                map.scrollWheelZoom.disable();
            }
            else {
                map.scrollWheelZoom.enable();
            }
        });
        let lat = 50.638589;
        let lng = 4.417500;
        // if ($(window).width() > 520) {
        map.setView([50.487931, 3.939686], 9);
        // let mapBounds = L.latLngBounds(L.latLng(53.531819,-7.768084), L.latLng(41.002288,11.651138));
        let mapBounds = L.latLngBounds(L.latLng(51.848674, 0.224355), L.latLng(48.868148, 9.652971));
        map.setMaxBounds(mapBounds);
        let belgiumBounds = L.latLngBounds(L.latLng(49.496407, 6.383176), L.latLng(51.511905, 2.534811));
        map.on('drag', function () {
            map.panInsideBounds(mapBounds, { animate: false });
        });
        let franceBounds = L.latLngBounds(L.latLng(51.417709, -5.304834), L.latLng(41.214614, 9.889973));
        // var overlay = new L.ImageOverlay("/app/themes/lumber/static/gfx/france-map.png", franceBounds);
        // map.addLayer(overlay);
        var overlay = new L.ImageOverlay("/app/themes/lumber/static/gfx/map/belgium-map.svg", belgiumBounds);
        map.addLayer(overlay);
        L.control.zoom({
            position: 'bottomright'
        }).addTo(map);
        //
        let icon = new L.Icon({
            iconUrl: '/app/themes/lumber/static/gfx/map/pointer.png',
            iconSize: [30, 30],
            iconAnchor: [15, 30],
            popupAnchor: [1, -30],
            shadowSize: [0, 0]
        });
    }
});
